import { Component } from 'react';
import ReactDOM from 'react-dom';

const overlayRoot = document.getElementById('overlay');

class Overlay extends Component
{
  constructor(props) {
    super(props);
    this.state = {}
    this.el = document.createElement('div');
  }

  componentDidMount() {
    overlayRoot.appendChild(this.el);
  }

  componentWillUnmount() {
    overlayRoot.removeChild(this.el);
  }

  render() {
    return ReactDOM.createPortal(this.props.children, this.el);
  }
}
export default Overlay
